<template>
  <v-flex xs12 sm12 md12 lg12 xl12>
    <head>
      <link href="https://vjs.zencdn.net/7.5.4/video-js.css" rel="stylesheet">
    </head>
      
    <Navbar></Navbar>

    <v-container class="">
      <v-layout row wrap>
        <v-flex xs12 sm6 md6 lg6 xl6 v-for="capacitacion in capacitaciones" :key="capacitacion.Video.unit">
          <v-card flat class=" pa-4 " style="background-color:#D6D6D6" >      
            <v-layout row wrap>

              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-card-title class="namevideo">
                  <v-flex xs3 sm3 md3 lg2 xl2>
                    <v-layout justify-center>
                      <div class="temacapacitacion" >
                        <span>{{capacitacion.Video.unit}}</span>
                      </div>
                    </v-layout>
                  </v-flex>

                  <v-flex xs7 sm7 md7 lg8 xl8>
                    <v-layout>
                      <div class="titlecapacitacion">{{capacitacion.Video.title}} </div>
                    </v-layout>
                  </v-flex>

                  <v-flex xs2 sm2 md2 lg2 xl1>
                    <v-layout justify-end>
                      <div class="text-right">
                        <img  :src="capacitacion.star" width="39.5px"/>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-card-title>   
              </v-flex>
            </v-layout> 

            <v-img :src="capacitacion.Video.img" width="100%">
              <div class="center">
                <v-img slot="activator" @click="mostrar(capacitacion.Video)" src="video.png" class="playvideo" width="300%" >
                  <span style="opacity:0">On</span>
                </v-img>
              </div>
            </v-img> 
                                   
          </v-card>
        </v-flex>
  
        <div class="center">
          <v-dialog v-model="dialog" width="850">
            <v-card style="border-radius:10px" class="pb-3">
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn  fab flat color="#B4347E" small @click="cerrar()">
                  <v-icon x-large>cancel</v-icon>
                </v-btn>
              </v-card-actions> 

              <Reproductor ref="repo">
              </Reproductor>
            </v-card>
          </v-dialog>
        </div>
      </v-layout>
    </v-container>

  </v-flex>
</template>

<script src='https://vjs.zencdn.net/7.5.4/video.js'></script>

<script>
  import Navbar from "@/components/Navbar.vue"
  import AvanceVideo from "../components/AvanceVideo.vue"
  import Reproductor from "../components/ReproductorLecciones.vue"
  import axios from 'axios'
  import VideoPlayer from "@/components/VideoPlayerLecciones.vue"
  

  //var tags = new Array("active","lesson","contexto","contexto social","actualidad","1.2");
  //var tags = new Array("active","lesson","concepto lalabum","lalabum","que contiene lalabum","que es lalabum","1.3");
  
  var list_capacitaciones;
  //var jsontags = JSON.stringify(json)



  export default {

    components:{
       Navbar,AvanceVideo,Reproductor
     },
     
    data(){

      return{
       dialog:false,
       capacitaciones:null,
       dialog_capacitacion:null,
      }
    },

    methods:{
      mostrar: function(cap) {
            this.$refs.repo.setContent(cap)
            this.dialog=true
                 
        },
        cerrar: function(){
          this.$refs.repo.Close()
          this.dialog=false
        } ,
        
        downloadItem (url,name) {
        axios.get(url, { responseType: 'blob' })
          .then(({ data }) => {
            const blob = new Blob([data], { type: 'audio/mpeg3' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = name
            link.click()
          }).catch(error => console.error(error))
        }
    },

    watch: {
    dialog(val){
      !val&&this.$refs.repo;
    }
  },

    mounted(){
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer '.concat(token);
      let tags = new Array("lesson");
      let user_progress;
        axios({
          url:"https://lalabumapp.com:4443/GetLessons",
          headers: { Authorization: AuthStr },
          method:"POST",
          responseType: 'json',
          data:{"tags":["lesson"]}
          
        }).then(resp => {      
          var Lessons = resp.data.data;
          this.capacitaciones=Lessons;
          Lessons.forEach(lesson => {
            if (lesson.Progress.is_completed) {
              lesson.star='estrella_verde.png'              
            }else{
              lesson.star='estrella_negra.png'
            }
                 
          });                       
        });
    }    
  }
</script>


<style scoped>

.titlecapacitacion{
    
    color: white;
    font-family: "Poppins";
    font-weight: 500;
    
  }

  .temacapacitacion{
    
    color: white;
    font-family: "Poppins";
    font-weight: bold;

  }
  .namevideo{
    background: url('../assets/numerodevideo.png');
    background-size: cover;
    color: white;
    

  }

@media (min-width: 750px){
  .titlecapacitacion{
    font-size: 1.4vw;   
  }

  .temacapacitacion{
    font-size: 2.5vw;
  }

  }

  @media (min-width: 300px) and (max-width: 750px){
    .titlecapacitacion{
    font-size: 3.4vw; 
    
  }

  .temacapacitacion{
    font-size: 8.5vw;
  }

  }

  .playvideo:hover {
  transform: scale(1.2);
  }

  .center {
  position:absolute; 
  top: 50%;
  left:50%;
  margin-top: -60px; 
  margin-left: -40px;
  }
.download{ 
  position: absolute; bottom:-104px; right: -252px;

}
 .download:hover {
  transform: scale(1.2);
}
</style>
